import { Route as RouteIcon } from "lucide-react";

import { useNavigation } from "@/providers";
import { RobotoButton } from "@/shared/components/RobotoButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";

import styles from "./CreateSessionButton.module.css";

interface CreateSessionButtonProps {
  /**
   * When set, prefills the create-session page's file selection from this dataset.
   * Omit on unscoped surfaces (e.g. the top-level `/sessions` page).
   */
  datasetId?: string;
}

/**
 * Toolbar entry point that opens the create-session flow. Rendered in the
 * `actions` slot of `<SessionsList>` on both the unscoped `/sessions` page
 * and the dataset-scoped Sessions tab.
 */
export function CreateSessionButton({ datasetId }: CreateSessionButtonProps) {
  const { goto } = useNavigation();

  return (
    <RobotoTooltip title="Create a new session">
      <span>
        <RobotoButton
          variant="outlined"
          size="small"
          startIcon={<RouteIcon size={16} />}
          eventName="CreateSessionClicked"
          eventProperties={{ datasetId }}
          className={styles.button}
          onClick={() => goto.createSession({ datasetId })}
        >
          New session
        </RobotoButton>
      </span>
    </RobotoTooltip>
  );
}
